import React from 'react';

import { capitalize, Grid, InputAdornment, TextField } from '@mui/material';
import { round } from 'lodash';
import useGetTvas from 'views/I9/hooks/useGetTvas';

const PrixEditionRapide = ({ values, handleChange }) => {
  const { tvasById } = useGetTvas();

  return values.tvalots.map((tvalot, index) => (
    <Grid sx={{ marginTop: '0.25em' }} key={tvalot.tva_lot_id} container spacing={3}>
      <Grid item xs={6}>
        <TextField
          fullWidth
          size='small'
          name={`tvalots[${index}].tva_lot_price`}
          label={`Prix TTC (${capitalize(tvalot.tva_lot_type)} - ${
            tvasById[tvalot.tva_lot_tva_taux_id]?.tva_taux_name
          })`}
          value={tvalot.tva_lot_price}
          onChange={handleChange}
          variant='outlined'
          InputProps={{
            endAdornment: <InputAdornment position='end'>€ TTC</InputAdornment>,
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          size='small'
          label={`Prix HT (${capitalize(tvalot.tva_lot_type)} - ${
            tvasById[tvalot.tva_lot_tva_taux_id]?.tva_taux_name
          })`}
          value={round(tvalot.tva_lot_price / (1 + tvalot.tva_taux.tva_taux_value / 100), 2)}
          variant='outlined'
          InputProps={{
            endAdornment: <InputAdornment position='end'>€ HT</InputAdornment>,
          }}
          disabled
        />
      </Grid>
    </Grid>
  ));
};

export default PrixEditionRapide;
